export const lineLikeSeriesMark = {
    point: {
        name: "point",
        type: "symbol"
    },
    line: {
        name: "line",
        type: "line"
    }
};
//# sourceMappingURL=constant.js.map
